import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { SimpleDialog, Typography } from '@nextiva/next-ui-components';

export const blockName = 'dialog';

const DialogComponent = ({
  callBack,
  contentText,
  positiveLabel,
  negativeLabel,
}) => {
  const [open, setOpen] = useState(true);

  /**
   * Handles dialog's closing functionality
   * @param {object} event
   */
  const handleClose = e => {
    callBack(e.target.textContent);
    setOpen(false);
  };

  return (
    <SimpleDialog
      open={open}
      dialogProps={{
        'aria-label': 'confirmation dialog',
        'data-testid': blockName,
      }}
      cancelText={negativeLabel}
      cancelButtonProps={{ onClick: handleClose }}
      confirmText={positiveLabel}
      confirmButtonProps={{
        color: 'primary',
        onClick: handleClose,
      }}
    >
      <Typography mb={3} variant="body1">
        {contentText}
      </Typography>
    </SimpleDialog>
  );
};

DialogComponent.propTypes = {
  callBack: PropTypes.func.isRequired,
  contentText: PropTypes.string.isRequired,
  positiveLabel: PropTypes.string.isRequired,
  negativeLabel: PropTypes.string.isRequired,
};

export default DialogComponent;
